     
export const commonOptions4 = [
    {
        id: 1,
        value: "All Categories",
    },
    {
        id: 2,
        value: "Bakery",
    },
    {
        id: 3,
        value: "Fruit and vegetable",
    },
    {
        id: 4,
        value: "Farm",
    },
    {
        id: 5,
        value: "Drinks",
    },
    {
        id: 6,
        value: "Kitchen",
    },
    {
        id: 7,
        value: "Special nutrition",
    },
    {
        id: 8,
        value: "Baby",
    },
    {
        id: 9,
        value: "Pharmacy",
    },
];
 